<template>
  <div class="tarjeta">
    <div class="container-img">
      <v-img v-if="isImage(name)" :src="itemUrl" width="42px"></v-img>
      <v-icon color="info" v-else size="32" class="document-icon">mdi-file-document</v-icon>
    </div>
    <div class="container-titulo">
      <a :href="itemUrl" target="_blank">{{ name }}</a>
      <div>
        <div class="container-autor">
          <span class="author-text">{{ author }} | {{ authorClub.nombre || 'LPF' }}</span>
        </div>
      </div>
    </div>
    <div class="desc-author-container" >
      <span v-if="description !== null"> <b>Descripción:</b> {{description}}</span>
    </div>
    <div v-if="this.$store.state.permissions.canDeleteAdjuntosFichaPartido && canDeleteAdjuntoByOwnClub()" @click="deleteAdjunto" class="delete-container">
        <v-btn icon color="primary"><v-icon color="6D6D6D">mdi-delete</v-icon></v-btn>
    </div>
  </div>
</template>

<script>
import Constants from '../../../common/constants'

export default {
  data () {
    return {
      dialog: false
    }
  },
  props: {
    name: null,
    id: null,
    itemUrl: null,
    description: null,
    author: null,
    authorClub: null,
    partidoId: null
  },
  methods: {
    goDetail () {
      const consultaId = this.detailId
      this.$emit('goDetailConsultaPartido', consultaId)
    },
    isImage (fileName) {
      return fileName.toLowerCase().match(Constants.ALLOWED_IMAGE_EXTENSIONS) != null
    },
    deleteAdjunto () {
      this.axios
        .delete(`partido/delete-s3/${this.id}/${this.partidoId}`)
        .then(response => {
          this.loading = false
          this.$router.go()
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    canDeleteAdjuntoByOwnClub () {
      if (this.$store.getters.isSafRole) {
        return true
      } else {
        return this.$store.getters.club === this.authorClub.nombre
      }
    }
  },
  created () {
  }
}
</script>

<style scoped>
.tarjeta{
  background-color: #FCFBFB;
  height: 80px;
  display: flex;
  align-items: center;
  flex-direction: row;
  overflow: hidden;
  border-bottom: 1px solid #d2c8c8;
}

.tarjeta:hover{
  background-color: #f6f5f5;
}

.container-img{
  margin-left: 30px;
  align-self: center;
}

.autor-name{
  margin-left: 6px;
}

.departamento{
  margin-left: auto;
  margin-right: 10px;
  max-width: 200px;
  text-align: end;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

span{
  font-size: 1.2em;
  color: #293968;
}

.container-titulo{
  display: flex;
  margin: 0 0 0 20px;
  font-size: 1.1rem;
  min-width: 280px;
  max-width: 280px;
  flex-direction: column;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.container-description{
  padding-left: 5px;
}

.info-icon{
  cursor: pointer;
  align-self: center;
}
.delete-container{
  margin: 0 0 0 auto;
  cursor: pointer;
}

.document-icon{
  width: 42px;
}

.desc-author-container{
  display: flex;
  flex-direction: column;
  margin: auto 5px auto 5px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
}
.author-text{
  font-size: small;
}

.container-autor{
  display: flex;
  flex-direction: row;
  align-items: center;
}

</style>
